import * as React from 'react';

import {CalendarToNutshellIcon} from 'shells/icon/svg/calendar-to-nutshell-icon';
import {GoogleCalendarToNutshellIcon} from 'shells/icon/svg/google-calendar-to-nutshell-icon';
import {NutshellToCalendarIcon} from 'shells/icon/svg/nutshell-to-calendar-icon';
import {NutshellToGoogleCalendarIcon} from 'shells/icon/svg/nutshell-to-google-calendar-icon';
import {NutshellToOffice365Icon} from 'shells/icon/svg/nutshell-to-office-365-icon';
import {Office365ToNutshellIcon} from 'shells/icon/svg/office-365-to-nutshell-icon';

import type {ExternalService} from 'nutshell-graphql-types';

export function getImportIcon(serviceName: ExternalService): React.ReactElement {
    if (serviceName === 'GOOGLE' || serviceName === 'GOOGLE_APPS') {
        return <GoogleCalendarToNutshellIcon size='80' />;
    } else if (serviceName === 'OFFICE365') {
        return <Office365ToNutshellIcon size='80' />;
    } else {
        return <CalendarToNutshellIcon size='80' />;
    }
}

export function getExportIcon(serviceName: ExternalService): React.ReactElement {
    if (serviceName === 'GOOGLE' || serviceName === 'GOOGLE_APPS') {
        return <NutshellToGoogleCalendarIcon size='80' />;
    } else if (serviceName === 'OFFICE365') {
        return <NutshellToOffice365Icon size='80' />;
    } else {
        return <NutshellToCalendarIcon size='80' />;
    }
}

/*
 * Generates a unique key for a component. Specifically for the RadioGroup
 * components, without unique keys the radio group selected values will conflict
 * with each other. Gives unique string like "abc123def"
 *
 * @returns {string} A unique key for a component.
 */
export function getComponentKey(): string {
    return Math.random().toString(36).substr(2, 9);
}
